var map = {
	"./alipay.svg": "261f",
	"./amex.svg": "c04a",
	"./default.svg": "dc6a",
	"./diners.svg": "62e8",
	"./discover.svg": "e562",
	"./elo.svg": "fcb0",
	"./hipercard.svg": "b8e3f",
	"./jcb.svg": "d8d9",
	"./maestro.svg": "b0a3",
	"./mastercard.svg": "87e3",
	"./paypal.svg": "f488",
	"./security-code.svg": "0a40",
	"./unionpay.svg": "1bc0",
	"./verve.svg": "c7e0",
	"./visa.svg": "964f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "98d4";